export type TrashQueryParameters = {
    allow_normal?: boolean;
    allow_deleted?: boolean;
};

export type ResolveTrashQueryParametersArgs = {
    /** True on the Trash Bin screen (resourceKeyName "trashBin"). */
    isTrashBin: boolean;
    /** Query params supplied by the surface (e.g. forced trash on a trashed container). */
    additionalQueryParameters?: TrashQueryParameters;
    /** The container itself is in the trash, so trashed rows must always be shown. */
    forcedAllowDeleted: boolean;
    /** Current state of the one-click "show records in trash" toggle. */
    showTrash: boolean;
};

/**
 * Resolve the effective fetch query parameters for a SearchTabs resource list,
 * given the one-click "show records in trash" toggle state.
 *
 * The Trash Bin screen drives its own trash/visibility choice via TrashBinFilter,
 * so its params pass through unchanged. On the container screens (project /
 * bundle / workspace default dashboard) normal (non-trashed) rows are always
 * shown and only trashed-row visibility flips; when the container itself is in
 * the trash, allow_deleted is forced on so the toggle cannot hide its contents.
 */
export const resolveTrashQueryParameters = ({
    isTrashBin,
    additionalQueryParameters = {},
    forcedAllowDeleted,
    showTrash,
}: ResolveTrashQueryParametersArgs): TrashQueryParameters =>
    isTrashBin
        ? additionalQueryParameters
        : {
              ...additionalQueryParameters,
              allow_normal: true,
              allow_deleted: forcedAllowDeleted || showTrash,
          };
